
import Vue from 'vue';
import {TitlebarAction} from '../../interfaces/titlebar-action-enum';
import {isNativeApp} from '../../utils/browser';

declare const Alkami: any;
declare const window: any;

export default Vue.extend({
  name: 'title-bar',
  data() {
    return {
      Alkami,
      window,
      firstUpdate: true
    };
  },
  props: {
    leftButton: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    rightButton: {
      type: Object,
      default: null,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    leftButton: 'updateTitleBar',
    rightButton: 'updateTitleBar',
    title: 'updateTitleBar',
    transparent: 'updateTitleBar',
  },
  methods: {
    updateTitleBar() {
      if (isNativeApp()) {
        const updateNavBar = this.firstUpdate ?
            (window as any).nativeHook.setNavBar :
            (window as any).nativeHook.updateNavBar;

        updateNavBar({
          left: this.leftButton,
          right: this.rightButton,
          text: this.title
        });
      }

      this.firstUpdate = false;

      if (isNativeApp()) {
        return;
      }

      const titleBarElement = document.querySelector('.titlebar');
      if (!titleBarElement) {
        throw new Error('Titlebar element not found');
      }
      const buttonElements = titleBarElement.querySelectorAll('.titlebar-button');
      const pageTitleElement = document.getElementById('page_title');
      const leftButtonElement = titleBarElement.querySelector('.titlebar-button--left') as HTMLButtonElement;
      const rightButtonElement = titleBarElement.querySelector('.titlebar-button--right') as HTMLButtonElement;

      if (!pageTitleElement) {
        throw new Error('Pagetitle element not found');
      }
      pageTitleElement.innerText = this.title || '';

      (Array.from(buttonElements) as HTMLElement[]).forEach((element: HTMLElement) => {
        element.classList.add('hidden');
        element.classList.remove('icon');
      });

      if (this.leftButton) {
        leftButtonElement.innerText = '';

        switch (this.leftButton.button) {
          case TitlebarAction.drawer:
            const navBtn = document.getElementById('nav_button');
            if (!navBtn) {
              throw new Error('Navbutton element not found');
            }
            navBtn.classList.remove('hidden');
            break;
          case TitlebarAction.back:
            leftButtonElement.setAttribute('href', 'javascript:' + this.leftButton.callback);
            leftButtonElement.classList.add('back');
            leftButtonElement.classList.add('icon');
            leftButtonElement.classList.remove('hidden');
            break;
          case TitlebarAction.custom:
            leftButtonElement.innerText = this.leftButton.text;
            leftButtonElement.setAttribute('href', 'javascript:' + this.leftButton.callback);
            leftButtonElement.classList.remove('hidden');
            break;
        }
      }

      if (this.rightButton) {
        Array.from(rightButtonElement.classList).forEach((className) => {
          if (className.startsWith('font-icon-')) {
            rightButtonElement.classList.remove(className);
          }
        });
        rightButtonElement.innerText = '';

        switch (this.rightButton.button) {
          case TitlebarAction.close:
            rightButtonElement.classList.add('font-icon-cancel-x');
            break;
          case TitlebarAction.custom:
            rightButtonElement.innerText = this.rightButton.text;
            break;
        }

        rightButtonElement.setAttribute('href', 'javascript:' + this.rightButton.callback);
        rightButtonElement.classList.remove('hidden');
      }
    }
  },
  async mounted() {
    const leftButtonElement = document.createElement('A');
    leftButtonElement.setAttribute('class', 'titlebar-button left icon hidden titlebar-button--left');

    const rightButtonElement = document.createElement('A');
    rightButtonElement.setAttribute('class', 'titlebar-button right hidden titlebar-button--right');

    const h1Element = document.createElement('h1');
    h1Element.setAttribute('id', 'page_title');
    h1Element.setAttribute('class', 'truncate');
    
    const titleBarElement = document.querySelector('.titlebar') as any;
    titleBarElement.prepend(leftButtonElement);
    titleBarElement.append(h1Element);
    titleBarElement.append(rightButtonElement);
    
    this.updateTitleBar();
  }
});
